//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
      data(){
          return {

          }
      },
      props:{
          headerText:{
              type:String,
              default:'default header'
          },
          headerConfig:{
              type:Object,
              default(){
                  return {
                    height:110/40+'rem',
                    backgroundColor:'#fff',
                    color:'#fff',
                    borderColor:'#eff1f4'
                  }
              }
          }
      },
      computed:{

      }
  }



// WEBPACK FOOTER //
// ./src/vue-components/article/article.vue